<template>
  <nav v-if="stepTotal > 0 && stepTotal > stepDataCount">
    <ul class="pagination justify-content-center p-3">
      <li :class="['page-item', {'disabled': getDisabledPreviousAndFirstItem || isDisable}]"
          @click="!isDisable ? selectedFirstCurrent() : {}"
      >
        <a class="page-link"> {{ resource['hrvenue.firstPagination'] }}</a>
      </li>

      <li :class="['page-item', {'disabled': getDisabledPreviousAndFirstItem || isDisable}]">
        <a class="page-link"
           @click="!isDisable ? backPrevious() : {}"
        >{{ resource['hrvenue.prevPagination'] }}</a>
      </li>

      <li v-for="(stepItem, stepIndex) in cmpShowItems"
      :key="stepIndex"
      :class="['page-item d-none d-md-block', {'active' : getClickedSameItem(stepItem)}, {'disabled': isDisable}]"
      @click="!getClickedSameItem(stepItem) && !isDisable ? selectedCurrent(stepItem) : null"
    >
      <a class="page-link" >{{ stepItem }}</a>
    </li>

      <li class="d-block d-md-none">
        <a class="page-link page-select">
          <multiselect id="step-pagination-select"
                       v-model="activeIndex"
                       :allow-empty="false"
                       :options="getArray(1, getTotalIndex)"
                       placeholder=""
                       @select="selectedCurrent"
          />
        </a>
      </li>

      <li :class="['page-item', {'disabled': getDisabledNextAndLastItem || isDisable}]"
          @click="!isDisable ? forwardNext() : {}"
      >
        <a class="page-link">{{ resource['hrvenue.nextPagination'] }}</a>
      </li>

      <li :class="['page-item', {'disabled': getDisabledNextAndLastItem || isDisable}]"
          @click="!isDisable ? selectedLastCurrent() : {}"
      >
        <a class="page-link">{{ resource['hrvenue.lastPagination'] }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'StepPagination',

  props: {
    stepTotal: {
      type: Number,
      default: null,
    },
    stepDataCount: {
      type: Number,
      default: null,
    },
    currentPageIndex: {
      type: Number,
      default: 1,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    queryParamName: {
      type: String,
      default: 'page',
    },
  },

  data() {
    return {
      showCountTotal: 9,
      medianCount: 5,
      activeIndex: 1,
    };
  },

  computed: {
    getTotalIndex() {
      return Math.ceil(+this.stepTotal / +this.stepDataCount);
    },

    cmpShowItems() {
      if (this.getTotalIndex < this.showCountTotal) {
        return this.getFirstItems;
      }
      if (
        this.getTotalIndex > this.showCountTotal
        && this.activeIndex + this.medianCount < this.getTotalIndex
        && this.activeIndex > this.medianCount
      ) {
        return this.getForIncrement;
      }
      if (
        this.getTotalIndex > this.showCountTotal
        && this.activeIndex + this.medianCount > this.getTotalIndex
      ) {
        return this.getLastItems;
      }
      return this.getShowCountTotal;
    },

    getFirstItems() {
      return this.getArray(1, this.getTotalIndex);
    },

    getShowCountTotal() {
      return this.getArray(1, this.showCountTotal);
    },

    getLastItems() {
      const firstItemCount = this.getTotalIndex - this.showCountTotal;
      const lastItemCount = this.getTotalIndex;
      return this.getArray(firstItemCount + 1, lastItemCount);
    },

    getForIncrement() {
      const diff = this.activeIndex - this.medianCount;
      const firstItemCount = diff + 1;
      const lastItemCount = this.showCountTotal + diff;
      return this.getArray(firstItemCount, lastItemCount);
    },

    getDisabledNextAndLastItem() {
      return this.activeIndex === this.getTotalIndex;
    },

    getDisabledPreviousAndFirstItem() {
      return this.activeIndex === 1;
    },
  },

  watch: {
    currentPageIndex: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.activeIndex = newVal;
        }
      },
      deep: true,
    },

    '$route.query': {
      handler(newQuery) {
        const pageFromQuery = parseInt(newQuery[this.queryParamName], 10);
        if (pageFromQuery && !isNaN(pageFromQuery) && pageFromQuery !== this.activeIndex) {
          if (pageFromQuery >= 1 && pageFromQuery <= this.getTotalIndex) {
            if (this.activeIndex !== pageFromQuery) {
              this.activeIndex = pageFromQuery;
              this.$emit('currentIndex', this.activeIndex);
            }
          }
        }
      },
      immediate: true,
    },
  },

  methods: {
    getArray(index, length) {
      const arr = [];
      for (let i = index; i <= length; i += 1) {
        arr.push(i);
      }
      return arr;
    },

    getClickedSameItem(stepItem) {
      return this.activeIndex === stepItem;
    },

    updateQueryParam() {
      const currentQuery = { ...this.$route.query };

      if (this.activeIndex === 1) {
        // Remove the page parameter when on page 1 (cleaner URL)
        delete currentQuery[this.queryParamName];
      } else {
        currentQuery[this.queryParamName] = this.activeIndex.toString();
      }

      // Update the URL without reloading the page
      this.$router.replace({ query: currentQuery }).catch((err) => {
        // Ignore navigation duplicated errors
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },

    selectedCurrent(selectedIndex) {
      this.activeIndex = selectedIndex;
      this.resetScroll();
      this.updateQueryParam();
      this.$emit('currentIndex', this.activeIndex);
    },

    forwardNext() {
      if (this.getDisabledNextAndLastItem) {
        this.activeIndex = this.getTotalIndex;
      } else {
        this.activeIndex += 1;
      }
      this.resetScroll();
      this.updateQueryParam();
      this.$emit('currentIndex', this.activeIndex);
    },

    backPrevious() {
      if (this.getDisabledPreviousAndFirstItem) {
        this.activeIndex = 1;
      } else {
        this.activeIndex -= 1;
      }
      this.resetScroll();
      this.updateQueryParam();
      this.$emit('currentIndex', this.activeIndex);
    },

    selectedFirstCurrent() {
      this.activeIndex = 1;
      this.resetScroll();
      this.updateQueryParam();
      this.$emit('currentIndex', this.activeIndex);
    },

    selectedLastCurrent() {
      this.activeIndex = this.getTotalIndex;
      this.resetScroll();
      this.updateQueryParam();
      this.$emit('currentIndex', this.activeIndex);
    },

    resetScroll() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    // Initialize from the URL query parameter if it exists
    const pageFromQuery = parseInt(this.$route.query[this.queryParamName], 10);
    if (pageFromQuery && !isNaN(pageFromQuery) && pageFromQuery <= this.getTotalIndex) {
      this.activeIndex = pageFromQuery;
    } else {
      this.activeIndex = this.currentPageIndex;
    }
  },
};
</script>

<style lang="scss">
@import "~@/style/starter.scss";
.pagination{
  .page-link {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    padding: 8px 12px !important;
    height: 36px !important;
    border-color:#E4E4E4 !important;
    color: inherit;
  }
}
.pagination {
  li.page-item {
    @include media-breakpoint-down(sm) {
      height: 45px;
      display: flex;
      align-items: center;
    }

    .page-link {
      @include media-breakpoint-down(sm) {
        height: 100%;
        display: flex !important;
        align-items: center;
      }
    }
    &:hover {
      cursor: pointer;
    }
  }

  li.page-item.active {
    .page-link {
      background-color: #353535 !important;
      border-color: #353535 !important;
      z-index: 0;
      color: #fff !important
    }

    &:hover {
      cursor: no-drop;
      color: white !important;
    }
  }

  .page-select {
    height: 45px;
    width: 62px;
    display: flex;
    align-items: center;
    padding: 0 5px;

    &:hover {
      background-color: white;
    }

    .multiselect {
      width: 55px;

      .multiselect__select {
        padding: 4px 1px;
      }

      .multiselect__tags {
        box-shadow: none;
        padding: 10px 20px 0 10px;
      }

      .multiselect__content-wrapper {
        width: 65px;
        right: -5px;
      }

      .multiselect__option--selected {
        &:after {
          content: ''
        }
      }
    }
  }
}
</style>
